module.exports = __webpack_public_path__ + "images/c54f1e03da6717fca77a42a1f2a90d8b.svg";